// src/components/StateComponents.tsx
import React from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  body: string;
  action?: { label: string; onClick: () => void };
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon = 'circle', title, body, action }) => {
  const icons: Record<string, string> = {
    circle: '○',
    square: '□',
    line: '—',
    checkmark: '✓',
  };

  return (
    <div className="state-empty">
      <div className="state-empty__icon">{icons[icon] || icons.circle}</div>
      <div className="state-empty__title">{title}</div>
      <div className="state-empty__body">{body}</div>
      {action && (
        <button
          onClick={action.onClick}
          style={{
            marginTop: '12px',
            background: 'transparent',
            border: '1px solid var(--border-soft)',
            borderRadius: 'var(--radius-sm)',
            padding: '8px 16px',
            color: 'var(--text-secondary)',
            fontSize: '12px',
            cursor: 'pointer',
            transition: 'all var(--duration-fast) var(--ease-default)',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = 'var(--border-active)';
            e.currentTarget.style.color = 'var(--text-primary)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = 'var(--border-soft)';
            e.currentTarget.style.color = 'var(--text-secondary)';
          }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

interface LoadingStateProps {
  text?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ text = 'loading...' }) => {
  return (
    <div className="state-loading">
      <div className="spinner" />
      <span className="text-caption" style={{ color: 'var(--text-muted)' }}>{text}</span>
    </div>
  );
};

interface ErrorStateProps {
  title: string;
  body: string;
  action?: { label: string; onClick: () => void };
}

export const ErrorState: React.FC<ErrorStateProps> = ({ title, body, action }) => {
  return (
    <div className="state-error">
      <div className="state-error__icon">◆</div>
      <div className="state-error__title">{title}</div>
      <div className="state-error__body">{body}</div>
      {action && (
        <button
          onClick={action.onClick}
          style={{
            background: 'transparent',
            border: '1px solid var(--border-soft)',
            borderRadius: 'var(--radius-sm)',
            padding: '8px 16px',
            color: 'var(--text-secondary)',
            fontSize: '12px',
            cursor: 'pointer',
          }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export default { EmptyState, LoadingState, ErrorState };
